var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('banner-image',{attrs:{"src":_vm.image},on:{"click":function($event){return _vm.goTo(_vm.link)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }